// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 273) return "static/chunks/273-b87d1ecd81bcee2c.js";
	if (chunkId === 523) return "static/chunks/523-da0015d1b437ff1e.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"254":"56c12eb5","970":"lottie"}[chunkId] || chunkId) + "." + {"254":"2f8f141ea937ab4a","687":"cb7c9664a57b9787","705":"c831975dbe45ea5e","970":"361a578344e8f4df"}[chunkId] + ".js";
};